import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'SettingsPage',
  props: {},
  methods: {},
  events: {
    widgetLoaded: {
      description: 'Fired when Widget loaded',
    },
  },
});
